import { AppBar, Badge, Button, styled } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { LogOutIcon } from 'lucide-react';
import { NavLink, useLocation } from 'react-router';
import arcLogo from '../../assets/images/arc-logo-white.svg';
import { useUserApi } from '../../services/api/useUser.api';
import { Role } from '../../types/enums/Role.enum';
import { useAuth } from '../Auth/AuthContext/AuthContext';

const Logo = styled('img')({
  width: '120px',
});

const NavLinksWrapper = styled('div')({
  display: 'flex',
  gap: '20px',
});

const NavigationLink = styled(NavLink)(({ theme }) => ({
  fontSize: '14px',
  textDecoration: 'none',
  color: `${theme.palette.primary.contrastText}`,

  '&.active': {
    fontWeight: '600',
  },
}));

const RightSection = styled('div')({
  marginLeft: 'auto',
});

function Navigation() {
  const { getUserInfo } = useUserApi();
  const { logout } = useAuth();

  const { data: user } = useQuery({
    queryKey: ['userInfo'],
    queryFn: getUserInfo,
  });

  const handleLogout = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const urlPath = useLocation();

  return (
    <>
      <AppBar
        position='sticky'
        sx={{
          top: 0,
          padding: 3,
          flexDirection: 'row',
          gap: 6,
          alignItems: 'center',
          borderRadius: '0 !important',
          border: 0,
          boxShadow: 'none',
          background:
            urlPath.pathname === '/help-center' || urlPath.pathname === '/eula' || urlPath.pathname === '/changelog'
              ? 'linear-gradient(94deg, #1b437f -21.51%, #021635 101.1%)'
              : 'primary.main',
        }}
      >
        <Logo src={arcLogo} alt='ARC Tool Logo' />
        <NavLinksWrapper>
          <NavigationLink to='/'>Overview</NavigationLink>
          <NavigationLink to='/resource-hub'>Resource Hub</NavigationLink>
          {user?.role?.id !== Role.MEMBER && <NavigationLink to='/settings'>Settings</NavigationLink>}
          <NavigationLink to='/help-center'>Help Center</NavigationLink>
          <NavigationLink to='/changelog'>
            Changelog
            {user?.id && user?.unread_changelogs_count > 0 && (
              <Badge
                sx={{
                  marginLeft: '4px',
                  background: '#fff',
                  color: 'primary.main',
                  fontSize: '11px',
                  borderRadius: '10px',
                  paddingX: '10px',
                }}
              >
                {user?.unread_changelogs_count}
              </Badge>
            )}
          </NavigationLink>
          <NavigationLink to='/feedback'>Feedback</NavigationLink>
        </NavLinksWrapper>
        <RightSection>
          {user?.role?.id === Role.SUPER_ADMIN && (
            <Button variant='outlined' color='secondary' sx={{ background: 'rgb(79 179 236 / 0.19)' }} disableElevation>
              <NavigationLink to='/super-admin/'>CPE Admin</NavigationLink>
            </Button>
          )}
          <Button
            sx={{ color: '#fff', fontWeight: 400 }}
            startIcon={<LogOutIcon size={16} />}
            variant='outlined'
            onClick={handleLogout}
          >
            Log out
          </Button>
        </RightSection>
      </AppBar>
    </>
  );
}

export default Navigation;
